import { NgModule } from "@angular/core";
import {
    RouterModule,
    Routes,
    UrlMatchResult,
    UrlSegment,
    UrlSegmentGroup,
} from "@angular/router";

import { MenuStateModule } from "@hermes/states/menu";

import { GridPageComponent } from "./components/grid-page/grid-page.component";
import { CategoryProductsResolver } from "./routing/category-products.resolver";
import { CategoryGuard } from "./routing/category.guard";
import { SearchProductsResolver } from "./routing/search-products.resolver";
import { SearchGuard } from "./routing/search.guard";

export function matchCategoryRoute(
    segments: UrlSegment[],
    group: UrlSegmentGroup,
): UrlMatchResult {
    return gridMatcher(group.segments, segments, "category");
}

export function matchSearchRoute(
    segments: UrlSegment[],
    group: UrlSegmentGroup,
): UrlMatchResult {
    return gridMatcher(group.segments, segments, "search");
}

/**
 * Will check first route segment from parent route
 * Match with path and consume all remaining segments
 */
export function gridMatcher(
    allSegments: UrlSegment[],
    remainingSegments: UrlSegment[],
    path: string,
): UrlMatchResult {
    if (allSegments[0] && path.includes(allSegments[0].path)) {
        return { consumed: remainingSegments };
    }
    return undefined;
}

const routes: Routes = [
    {
        matcher: matchCategoryRoute,
        canActivate: [CategoryGuard],
        resolve: {
            products: CategoryProductsResolver,
        },
        data: { isSearch: false },
        component: GridPageComponent,
    },
    {
        matcher: matchSearchRoute,
        canActivate: [SearchGuard],
        resolve: {
            products: SearchProductsResolver,
        },
        data: { isSearch: true },
        component: GridPageComponent,
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes), MenuStateModule],
    exports: [RouterModule],
    providers: [
        CategoryGuard,
        CategoryProductsResolver,
        SearchProductsResolver,
        SearchGuard,
    ],
})
export class GridPageRoutingModule {}
